import { Folder } from '@anm/api/modules/videoFolder';
import asyncEntityHandlers from '@anm/helpers/redux/asyncEntityHandlers';
import reduceFactory from '@anm/helpers/redux/reduceFactory';
import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { initialVideoFolderState } from '..';
import { moveProjectToOtherAsync } from '../../actions';
import { findAndUpdateFolder, removeProject } from '../../helpers';
import { VideoFolderActions } from '../../types';

const moveProjectToOtherWorkspaceReducer: Reducer<typeof initialVideoFolderState, VideoFolderActions> = (
  state = initialVideoFolderState,
  action
) => {
  switch (action.type) {
    case getType(moveProjectToOtherAsync.success): {
      const { folderId, projectId } = state.moveProjectToOtherWorkspace.params!;

      const increaseProjectsCount = ({ projectsCount = 0, ...other }: Folder) => ({
        ...other,
        projectsCount: projectsCount + 1
      });

      const decreaseProjectsCount = ({ projectsCount = 1, ...other }: Folder) => ({
        ...other,
        projectsCount: projectsCount - 1
      });

      const increasedCountData = findAndUpdateFolder(state.folderTree.data!, folderId)(increaseProjectsCount);
      const decreasedCountData = findAndUpdateFolder(increasedCountData, state.data!.id)(decreaseProjectsCount);

      return {
        ...state,
        data: removeProject(state.data!, projectId),
        folderTree: {
          ...state.folderTree,
          data: decreasedCountData
        },
        moveProjectToOtherWorkspace: {
          ...state.moveProjectToOtherWorkspace,
          isPending: false
        }
      };
    }

    default:
      return reduceFactory(initialVideoFolderState, {
        ...asyncEntityHandlers<typeof initialVideoFolderState>(moveProjectToOtherAsync, 'moveProjectToOtherWorkspace')
      })(state, action);
  }
};

export default moveProjectToOtherWorkspaceReducer;
